import { PersonModel } from "@/Domains/Person";
import { Entity } from "../Types";
import { RecordMap } from "./record-map";

export function shallowEqual(obj1?: Record<string, any>, obj2?: Record<string, any>): boolean {
	if (obj1 === obj2) return true;
	if (!obj1 || !obj2) return false;

	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) return false;

	for (const key of keys1) {
		if (obj1[key] !== obj2[key]) return false;
	}
	return true;
}

export function downloadBlob(blob: Blob, filename: string) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url); // nettoyage
}


export function openOrDownloadFile(blob: Blob, filename: string) {
    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Check the file type (MIME type) to decide behavior
    if (blob.type === 'application/pdf') {
        
		// Open PDF in a new tab
        const newTab = window.open(url, '_blank');
        if (!newTab) {
            console.warn('Unable to open a new tab. Check if pop-ups are blocked.');
        } else {
            newTab.document.title = filename; // Optional: set tab title
        }

        // Clean up after 10 seconds (browser may also release automatically)
        setTimeout(() => URL.revokeObjectURL(url), 10000);
    } else {
        
		// For non-PDF files (Excel, Word, etc.), trigger download
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        // Clean up the object URL
        URL.revokeObjectURL(url);
    }
}


export function groupBy<T>(array: T[], getKey: (item: T) => string): Record<string, T[]> {
	const result: Record<string, T[]> = {};
	for (const item of array) {
		const key = getKey(item);
		if (!result[key]) {
			result[key] = [];
		}
		result[key].push(item);
	}
	return result;
}

export function depByTouch<T extends Entity>(map: RecordMap<T>) : number {
    let touchedAtItems = map.toArray().map(item => item.touchedAt ? Date.parse(item.touchedAt) : 0);
    return Math.max(...touchedAtItems);
}


export function stringCompare(a : string, b : string, sensitivity :  "base" | "accent" | "case" | "variant" = 'base') {
    return a.localeCompare(b, 'fr', { sensitivity })
}

export const dateCompare = (d1?: Date | string | null, d2?: Date | string | null): number => {
    if(!d1) return -1;
    if(!d2) return 1;
	return new Date(d1).getTime() - new Date(d2).getTime();
};


export function toCamelCase(type: string): string {
    return type.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
}


// Utility function to sort objects by their "label" property
export const sortByLabel = (a: { label: string }, b: { label: string }) => {
	return stringCompare(a.label, b.label);
};

export const formatName = (person? : PersonModel) => {
	return (person?.lastname ?? "").toUpperCase() + " " + (person?.firstname ?? "");
}

export const isArrayEquals = (arr1: any[], arr2: any[]) => {
    if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
    
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    
    return sorted1.every((val, index) => val === sorted2[index]);
}